import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    InputType,
    ActionType,
} from "../services/types/ComponentTypes";

export const screen_175_proforma_invoice_add: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Proforma Invoice",
        BindValue: "cont_invoice",
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                Label: "",
                BindValue: "cont_Action",
                style: {
                    direction: FlexDirection.ROW,
                    padding: 5,
                    margin: 0,
                    marginBottom: 8,
                    gap: 8,
                },
                childComponents: [
                    {
                        componentType: ComponentType.BUTTON,
                        Label: "Edit",
                        BindValue: "btn_Edit",
                        ActionType: ActionType.EDIT,
                        ScreenId: "38",
                        LockBinding: true,
                        Enabled: {
                            Enable: {
                                Json_Attribute: "current_state",
                                values: ["Invoiced"],
                            },
                            Mode: ["View"],
                        },
                        style: {
                            backgroundColor: "var(--primary-green)",
                            textColor: "#FFFFFF",
                            padding: 8,
                            marginBottom: 8,
                            borderRadius: 4,
                            fontSize: 14,
                        },
                    },
                    {
                        componentType: ComponentType.BUTTON,
                        Label: "lock",
                        BindValue: "lock",
                        LockBinding: true,
                        style: {
                            backgroundColor: "var(--primary-green)",
                            textColor: "#FFFFFF",
                            padding: 8,
                            marginBottom: 8,
                            borderRadius: 4,
                            fontSize: 14,
                        },
                    },
                    {
                        componentType: ComponentType.BUTTON,
                        Label: "Print",
                        BindValue: "btn_Print",
                        onPressAction: "pdf",
                        Settings: "proforma_invoice_pdf_view",
                        Enabled: {
                            Mode: ["View"],
                        },
                        style: {
                            backgroundColor: "var(--primary-green)",
                            textColor: "#FFFFFF",
                            padding: 8,
                            marginBottom: 8,
                            borderRadius: 4,
                            fontSize: 14,
                        },
                    },
                ],
            },
            {
                componentType: LayoutTypes.FORM,
                Name: "proforma_invoice_add",
                BindValue: "proforma_invoice_add",
                TableName: "proforma_invoice",
                DisplayName: "",
                columnNumber: "m1 t1 w1",
                LockOnSubmit: true,
                DisableSubmit: true,
                SubmitActions: [
                    {
                        Action: "Navigate",
                        Navigate: "modulev1/proforma_invoice_summary",
                    },
                ],
                Fields: [
                    {
                        componentType: LayoutTypes.FIELD_GROUP,
                        Label: "Invoice Details",
                        BindValue: "cont_invoice_details",
                        childComponents: [
                            {
                                IncludeLabel: true,
                                Label: "Invoice No.",
                                PlaceHolder: "Will be auto generated...",
                                IsMandatory: false,
                                BindValue: "txt_inv_no_",
                                Json_Attribute: "invoice_no",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsReadOnly: true,
                                AutoPopulate: true,
                                AutoPopulate_format: "PINV_[******]",
                                IsVerticalView: true,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Estimation No.",
                                PlaceHolder: "",
                                IsMandatory: true,
                                BindValue: "parentid1",
                                Json_Attribute: "parent_id",
                                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                                showInSummary: false,
                                LookupName: "estimation_no_proforma_search_Select",
                                IsVerticalView: true,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Customer type",
                                PlaceHolder: "",
                                IsMandatory: true,
                                BindValue: "s_select_customertype_",
                                Json_Attribute: "customertype",
                                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                                showInSummary: false,
                                LookupName: "customer_type",
                                IsVerticalView: true,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Customer name",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "s_select_insurance_customertype_",
                                Json_Attribute: "insurance_name",
                                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                                showInSummary: false,
                                LookupName: "insurance_customer",
                                Parent_Field: "s_select_customertype_",
                                IsVerticalView: true,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Invoice date",
                                PlaceHolder: "inv_date",
                                IsMandatory: true,
                                BindValue: "txt_jobdate_",
                                Json_Attribute: "invoice_date",
                                componentType: ComponentType.DATETIME_FIELD,
                                showInSummary: false,
                                IsVerticalView: true,
                            },
                            {
                                IncludeLabel: true,
                                Label: "LPO No.",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_lpo",
                                Json_Attribute: "lpo_number",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsReadOnly: false,
                                IsVerticalView: true,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Claim No.",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_claim_no",
                                Json_Attribute: "claim_no",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsReadOnly: false,
                                IsVerticalView: true,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Remarks",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_remarks",
                                Json_Attribute: "remarks",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsReadOnly: false,
                                IsVerticalView: true,
                            },
                        ],
                    },
                    {
                        componentType: ComponentType.SUB_MODULE,
                        Label: "Spare parts",
                        BindValue: "sub_spareparts_",
                        tableName: "proforma_invoice_spareparts",
                        name: "proforma_invoice_spareparts",
                        lookupName: "invoice_items",
                        parentField: "parentid1",
                        childControls: [
                            {
                                IncludeLabel: true,
                                Label: "code",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "drp_code",
                                Json_Attribute: "codeid",
                                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                                showInSummary: false,
                                IsReadOnly: false,
                                LookupName: "product_itemcode",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Qty",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_qty",
                                Json_Attribute: "qty",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                Default_Value: "1",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Rate",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_rate",
                                Json_Attribute: "rate",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                Default_Value: "0",
                               // ExpressionV2: "[drp_code.sale_rate]",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Unit discount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_unit_discount",
                                Json_Attribute: "unit_discount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                IsVerticalView: true,
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Total discount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_line_discount",
                                Json_Attribute: "line_discount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[txt_unit_discount] * [txt_qty]",
                                Default_Value: "0",
                                IsVerticalView: true,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_amount",
                                Json_Attribute: "amount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[txt_rate] * [txt_qty]",
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: true,
                                Label: "VAT%",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "drp_vat",
                                Json_Attribute: "vat_id",
                                componentType: ComponentType.SELECT_DROPDOWN,
                                showInSummary: false,
                                LookupName: "tax_rates",
                                IncludeNotSet: false,
                            },
                            {
                                IncludeLabel: true,
                                Label: "VAT amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_vat_amt",
                                Json_Attribute: "vat_amt",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "([txt_amount] - [txt_line_discount]) * ([drp_vat.taxrate]/100)",
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Net amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_net_amt",
                                Json_Attribute: "net_amt",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "([txt_amount] - [txt_line_discount]) + [txt_vat_amt]",
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Department",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "drp_department",
                                Json_Attribute: "department_id",
                                componentType: ComponentType.SELECT_DROPDOWN,
                                showInSummary: false,
                                LookupName: "department",
                            },
                        ],
                        FooterControls: [
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                BindValue: "txt_one",
                                style: { display: "none" },
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                BindValue: "txt_2",
                                style: { display: "none" },
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                BindValue: "txt_3",
                                style: { display: "none" },
                            },
                            {
                                IncludeLabel: false,
                                Label: "Amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_sub_amount",
                                Json_Attribute: "spare_amount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[SUM:txt_amount] ",
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: false,
                                Label: "Total discount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "spare_line_discount_total",
                                Json_Attribute: "spare_line_discount_total",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[SUM:txt_line_discount]",
                                Default_Value: "0",
                                inputType: InputType.NUMBER,
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                BindValue: "txt_6",
                                style: { display: "none" },
                            },
                            {
                                IncludeLabel: false,
                                Label: "vat Amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "spare_vat_amount",
                                Json_Attribute: "spare_vat_amount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[SUM:txt_vat_amt] ",
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: false,
                                Label: "Net Amount", // Changed Label to distinguish
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_sub_net_amount",
                                Json_Attribute: "spare_net_amount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[SUM:txt_net_amt] ",
                                Default_Value: "0",
                            },
                        ],
                    },
                    {
                        componentType: ComponentType.SUB_MODULE,
                        Label: "Labour/Others",
                        BindValue: "proforma_invoice_labour",
                        tableName: "proforma_invoice_labour",
                        name: "proforma_invoice_labour",
                        lookupName: "invoice_labour",
                        parentField: "parentid1",
                        childControls: [
                            {
                                IncludeLabel: true,
                                Label: "code",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "drp_code",
                                Json_Attribute: "codeid",
                                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                                showInSummary: false,
                                LookupName: "itemcode",
                                Parent_Field: "drp_jobtype",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Qty",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_qty",
                                Json_Attribute: "qty",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Rate",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_rate",
                                Json_Attribute: "rate",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                               // ExpressionV2: "[drp_code.sale_rate]",
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Unit discount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_unit_discount",
                                Json_Attribute: "unit_discount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                IsVerticalView: true,
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Total discount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_line_discount",
                                Json_Attribute: "line_discount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[txt_unit_discount] * [txt_qty]",
                                Default_Value: "0",
                                IsVerticalView: true,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_amount",
                                Json_Attribute: "amount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[txt_rate] * [txt_qty]",
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: true,
                                Label: "VAT%",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "drp_vat",
                                Json_Attribute: "vat_id",
                                componentType: ComponentType.SELECT_DROPDOWN,
                                showInSummary: false,
                                LookupName: "tax_rates",
                                IncludeNotSet: false,
                            },
                            {
                                IncludeLabel: true,
                                Label: "VAT amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_vat_amt",
                                Json_Attribute: "vat_amt",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "([txt_amount] - [txt_line_discount]) * ([drp_vat.taxrate]/100)",
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Net amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_net_amt",
                                Json_Attribute: "net_amt",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "([txt_amount] - [txt_line_discount]) + [txt_vat_amt]",
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Department",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "drp_department",
                                Json_Attribute: "department_id",
                                componentType: ComponentType.SELECT_DROPDOWN,
                                showInSummary: false,
                                LookupName: "department",
                            },
                        ],
                        FooterControls: [
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                BindValue: "txt_one",
                                style: { display: "none" },
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                BindValue: "txt_2",
                                style: { display: "none" },
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                BindValue: "txt_3",
                                style: { display: "none" },
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                BindValue: "txt_7",
                                style: { display: "none" },
                            },
                            {
                                IncludeLabel: false,
                                Label: "Amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_sub_amount",
                                Json_Attribute: "labour_amount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[SUM:txt_amount]",
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: false,
                                Label: "Total discount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "labour_line_discount_total",
                                Json_Attribute: "labour_line_discount_total",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[SUM:txt_line_discount]",
                                Default_Value: "0",
                                inputType: InputType.NUMBER,
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                BindValue: "txt_8",
                                style: { display: "none" },
                            },
                            {
                                IncludeLabel: false,
                                Label: "vat Amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "labour_vat_amount",
                                Json_Attribute: "labour_vat_amount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[SUM:txt_vat_amt] ",
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: false,
                                Label: "Net amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_sub_net_amount", // Fixed from JSON which seemed to have 'txt_sub_net_amount' same as spare
                                Json_Attribute: "labour_net_amount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[SUM:txt_net_amt]",
                                Default_Value: "0",
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                BindValue: "txt_8",
                                style: { display: "none" },
                            },
                        ],
                    },
                    {
                        componentType: ComponentType.SUB_MODULE,
                        Label: "Miscellaneous",
                        BindValue: "proforma_invoice_miscellaneous",
                        tableName: "proforma_invoice_miscellaneous",
                        name: "proforma_invoice_miscellaneous",
                        lookupName: "invoice_miscellaneous",
                        parentField: "parentid1",
                        childControls: [
                            {
                                IncludeLabel: true,
                                Label: "Item type",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "drp_item_type",
                                Json_Attribute: "item_type",
                                componentType: ComponentType.SELECT_DROPDOWN,
                                showInSummary: false,
                                LookupName: "item_type",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Item name",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "item_name",
                                Json_Attribute: "item_name",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsReadOnly: false,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Qty",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_qty",
                                Json_Attribute: "qty",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                Default_Value: "1",
                                ControlWidth: "130px",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Rate",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_rate",
                                Json_Attribute: "rate",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: false,
                               // ExpressionV2: "[drp_code.sale_rate]",
                                ControlWidth: "130px",
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Unit discount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_unit_discount",
                                Json_Attribute: "unit_discount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                IsVerticalView: true,
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Total discount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_line_discount",
                                Json_Attribute: "line_discount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[txt_unit_discount] * [txt_qty]",
                                Default_Value: "0",
                                IsVerticalView: true,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_amount",
                                Json_Attribute: "amount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[txt_rate] * [txt_qty]",
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: true,
                                Label: "VAT%",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "drp_vat",
                                Json_Attribute: "vat_id",
                                componentType: ComponentType.SELECT_DROPDOWN,
                                showInSummary: false,
                                LookupName: "tax_rates",
                                IncludeNotSet: false,
                            },
                            {
                                IncludeLabel: true,
                                Label: "VAT amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_vat_amt",
                                Json_Attribute: "vat_amt",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "([txt_amount] - [txt_line_discount]) * ([drp_vat.taxrate]/100)",
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Net amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_net_amt",
                                Json_Attribute: "net_amt",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "([txt_amount] - [txt_line_discount]) + [txt_vat_amt]",
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: true,
                                Label: "Department",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "drp_department",
                                Json_Attribute: "department_id",
                                componentType: ComponentType.SELECT_DROPDOWN,
                                showInSummary: false,
                                LookupName: "department",
                            },
                        ],
                        FooterControls: [
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                BindValue: "txt_7",
                                style: { display: "none" },
                            },
                            {
                                IncludeLabel: false,
                                Label: "Amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_sub_amount",
                                Json_Attribute: "miscellaneous_amount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[SUM:txt_amount]",
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: false,
                                Label: "Total discount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "misc_line_discount_total",
                                Json_Attribute: "misc_line_discount_total",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[SUM:txt_line_discount]",
                                Default_Value: "0",
                                inputType: InputType.NUMBER,
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                BindValue: "txt_8",
                                style: { display: "none" },
                            },
                            {
                                IncludeLabel: false,
                                Label: "VAT amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "miscellanious_vat_amount",
                                Json_Attribute: "miscellanious_vat_amount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[SUM:txt_vat_amt] ",
                                Default_Value: "0",
                            },
                            {
                                IncludeLabel: false,
                                Label: "Net amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_sub_net_amount",
                                Json_Attribute: "miscellaneous_net_amount",
                                componentType: ComponentType.TEXT_FIELD,
                                inputType: InputType.NUMBER,
                                showInSummary: false,
                                IsReadOnly: true,
                                ExpressionV2: "[SUM:txt_net_amt]",
                                Default_Value: "0",
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                BindValue: "txt_8",
                                style: { display: "none" },
                            },
                        ],
                    },
                    {
                        IncludeLabel: true,
                        Label: "Excess charge",
                        PlaceHolder: "",
                        IsMandatory: false,
                        BindValue: "txt_excess_charge",
                        Json_Attribute: "excess_charge",
                        componentType: ComponentType.TEXT_FIELD,
                        inputType: InputType.NUMBER,
                        showInSummary: false,
                        IsReadOnly: false,
                        Default_Value: "0",
                    },
                    {
                        IncludeLabel: true,
                        Label: "Total discount",
                        PlaceHolder: "",
                        IsMandatory: false,
                        BindValue: "txt_discount",
                        Json_Attribute: "discount",
                        componentType: ComponentType.TEXT_FIELD,
                        inputType: InputType.NUMBER,
                        showInSummary: false,
                        IsReadOnly: true,
                        Default_Value: "0",
                        ExpressionV2:
                            "[(proforma_invoice_spareparts).spare_line_discount_total] + [(proforma_invoice_labour).labour_line_discount_total] + [(proforma_invoice_miscellaneous).misc_line_discount_total]",
                    },
                    {
                        IncludeLabel: true,
                        Label: "Round off",
                        PlaceHolder: "",
                        IsMandatory: false,
                        BindValue: "txt_round_off",
                        Json_Attribute: "round_off_amt",
                        componentType: ComponentType.TEXT_FIELD,
                        inputType: InputType.NUMBER,
                        showInSummary: false,
                        IsReadOnly: true,
                        AllowNegative: true,
                        Default_Value: "0",
                        BindParent: {
                            parentid1: "round_off_amt",
                        },
                    },
                    {
                        IncludeLabel: true,
                        Label: "Vat amount",
                        PlaceHolder: "",
                        IsMandatory: false,
                        BindValue: "gross_vat_amount",
                        Json_Attribute: "gross_vat_amount",
                        componentType: ComponentType.TEXT_FIELD,
                        inputType: InputType.NUMBER,
                        showInSummary: false,
                        IsReadOnly: true,
                        ExpressionV2:
                            "[(proforma_invoice_spareparts).spare_vat_amount] + [(proforma_invoice_labour).labour_vat_amount]+[(proforma_invoice_miscellaneous).miscellanious_vat_amount]",
                        Default_Value: "0",
                    },
                    {
                        IncludeLabel: true,
                        Label: "Gross amount",
                        PlaceHolder: "",
                        IsMandatory: false,
                        BindValue: "gross_amount",
                        Json_Attribute: "gross_amount",
                        componentType: ComponentType.TEXT_FIELD,
                        inputType: InputType.NUMBER,
                        showInSummary: false,
                        IsReadOnly: true,
                        ExpressionV2:
                            "[(proforma_invoice_spareparts).txt_sub_amount] + [(proforma_invoice_labour).txt_sub_amount]+[(proforma_invoice_miscellaneous).txt_sub_amount]",
                        Default_Value: "0",
                    },
                    {
                        IncludeLabel: true,
                        Label: "Total amount",
                        PlaceHolder: "",
                        IsMandatory: false,
                        BindValue: "txt_total_amount",
                        Json_Attribute: "amount",
                        componentType: ComponentType.TEXT_FIELD,
                        inputType: InputType.NUMBER,
                        showInSummary: false,
                        IsReadOnly: true,
                        ExpressionV2:
                            "[(proforma_invoice_labour).txt_sub_net_amount] + [(proforma_invoice_spareparts).txt_sub_net_amount]+[(proforma_invoice_miscellaneous).txt_sub_net_amount] - [txt_excess_charge] - [txt_round_off]",
                        Default_Value: "0",
                    },
                    {
                        componentType: LayoutTypes.GROUP,
                        Label: "",
                        BindValue: "cont_FooterAction",
                        style: {
                            direction: FlexDirection.ROW,
                            padding: 5,
                            marginTop: 10,
                            gap: 8,
                            justifyContent: "flex-end"
                        },
                        childComponents: [
                            {
                                componentType: ComponentType.BUTTON,
                                Label: "Submit",
                                BindValue: "submit",
                                ActionType: "Add",
                                Navigate: "174",
                                style: {
                                    backgroundColor: "var(--primary-color)",
                                    textColor: "#FFFFFF",
                                },
                                onPressAction: "save",
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
